import React from "react";
import Dashboard from "../views/Dashboard";
import ComingSoon from "../components/comingSoon";
import NotificationList from "../views/Notification";
import ListTemplate from "../views/Templates/List";
import AddTemplate from "../views/Templates/Add";
import EditTemplate from "../views/Templates/Edit";
import { FaHome } from "react-icons/fa";
import { IoNotifications } from "react-icons/io5";
import { FaRegCircle } from "react-icons/fa";

const HomeRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <FaHome />,
    component: <Dashboard />,
    layout: "/admin",
    showInSidebar: true
  },
  {
    name: "Notification",
    icon: <IoNotifications />,
    iconDown: "nc-icon nc-minimal-down",
    layout: "/admin",
    showInSidebar: true,
    subNav: [
      {
        path: "/notifications/list",
        title: "Notification",
        icon: <FaRegCircle />,
        component: <NotificationList/>,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true,
      },
      {
        path: "/template/list",
        title: "Templates",
        icon: <FaRegCircle />,
        component: <ListTemplate />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true,
      }
    ],
  },
  {
    path: "/template/add",
    name: "Add Template",
    icon: "nc-icon nc-bank",
    component: <AddTemplate />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/template/edit",
    name: "Edit Template",
    icon: "nc-icon nc-bank",
    component: <EditTemplate />,
    layout: "/admin",
    showInSidebar: false
  },
];

export default HomeRoutes;
